<template>
  <div>
    <a href="#" class="btn-add-category" @click.prevent.stop="fetchData">
      {{ issueBsoEdit ? $t('Редактировать') : $t('Выдать БСО') }}
    </a>
    <v-dialog v-model="dialog" max-width="800">
      <v-card class="modal issue-bso-form-modal">
        <div class="modal-head">
          {{ $t('Выдача БСО') }}
          <v-btn color="modal-close" @click.native.stop="dialog = false">
            <img src="@/assets/img/close-icon.png" alt="icon">
          </v-btn>
        </div>
        <div class="modal-body">
          <v-form
            ref="form"
            lazy-validation
            @submit.prevent="createUpdateIssueBsos"
          >
            <h4>{{ data.typeName }}</h4>
            <table class="table-full">
                <thead>
                <tr>
                  <th rowspan="2" class="text-center">{{ $t('Тип БСО') }}</th>
                  <th rowspan="2" class="text-center">№ {{ $t('БСО') }}</th>
                  <th colspan="2" class="text-center">{{ $t('Срок действия') }}</th>
                </tr>
                <tr>
                  <th class="text-center">{{ $t('С') }}</th>
                  <th class="text-center">{{ $t('По') }}</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) in bsoData" :key="index">
                  <td>{{ item.strictReportingTypeName }}</td>
                  <td>
                    <div class="select-def" :class="{ invalid: $v.faunaLicenseApplicationData.bsoId.$error && !faunaLicenseApplicationData[index]['bsoId'] }">
                      <v-select
                        :items="item.bsos"
                        item-value="id"
                        item-text="number"
                        v-model="faunaLicenseApplicationData[index]['bsoId']"
                        outlined
                        dense
                        required
                        clearable
                      />
                    </div>
                  </td>
                  <td>
                    <div class="datepicker-main" v-if="item.trophy === false">
                      <div class="form-date">
                        <v-icon class="date-icon">date_range</v-icon>
                        <VueCtkDateTimePicker
                          v-model="faunaLicenseApplicationData[index]['validDateFrom']"
                          format="DD.MM.YYYY"
                          formatted="LL"
                          :onlyDate="true"
                          :label="$t('Дата')"
                          :autoClose="true"
                          :noButton="true"
                          @input="changeDate"
                        />
                      </div>
                    </div>
                  </td>
                  <td>
                    <div class="datepicker-main" v-if="item.trophy === false">
                      <div class="form-date">
                        <v-icon class="date-icon">date_range</v-icon>
                        <VueCtkDateTimePicker
                          v-model="faunaLicenseApplicationData[index]['validDateTo']"
                          format="DD.MM.YYYY"
                          formatted="LL"
                          :onlyDate="true"
                          :label="$t('Дата')"
                          :autoClose="true"
                          :noButton="true"
                          @input="changeDate"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
                </tbody>
            </table>
            <div class="form-action text-center">
              <button
                class="btn btn-default blue"
                type="submit"
              >{{ $t('Сохранить') }}
              </button>
              <button
                class="btn btn-default"
                type="button"
                @click="onCancel"
              >{{ $t('Закрыть') }}
              </button>
            </div>
          </v-form>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { mapMutations } from 'vuex'
import License from '@/model/license'

export default {
  props: {
    licenseApplicationId: Number,
    issueBsoEdit: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    data: {},
    bsoData: [],
    dialog: false,
    faunaLicenseApplicationData: [],
    rules: {
      faunaLicenseApplicationData: {
        bsoId: {}
      }
    },
    faunaLicenseApplicationValidateState: false
  }),
  validations () {
    if (!this.faunaLicenseApplicationValidate) {
      this.rules.faunaLicenseApplicationData.bsoId = { required }
    } else {
      this.rules.faunaLicenseApplicationData.bsoId = {}
    }
    return this.rules
  },
  computed: {
    faunaLicenseApplicationValidate () {
      return this.faunaLicenseApplicationValidateState
    }
  },
  methods: {
    ...mapMutations(['setLoading']),
    changeDate () {
      this.$forceUpdate()
    },
    fetchData () {
      License.getBsosForApplicationPermit(this.licenseApplicationId)
        .then((response) => {
          this.data = response.data
          this.bsoData = response.data.bsoData
          this.bsoData.forEach((item, index) => {
            const applicationBso = item.applicationBso
            this.faunaLicenseApplicationData[index] = {
              bsoId: applicationBso ? applicationBso.bsoId : null,
              validDateFrom: (applicationBso && applicationBso.validDateFrom) ? applicationBso.validDateFrom : null,
              validDateTo: (applicationBso && applicationBso.validDateTo) ? applicationBso.validDateTo : null,
              faunsLicenseApplicationId: item.faunsLicenseApplicationId,
              faunaLicenseApplicationBsoId: applicationBso ? applicationBso.id : null
            }
          })
          this.dialog = true
        })
        .catch((error) => {
          console.log(error)
          this.$noty.error(this.$i18n.t('Внимание! Для данного вида уже выданы БСО'), {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
          this.dialog = false
        })
    },
    createUpdateIssueBsos () {
      const bsoIds = []
      this.faunaLicenseApplicationData.forEach(element => {
        if (typeof element.bsoId === 'number') {
          this.faunaLicenseApplicationValidateState = true
        } else {
          this.faunaLicenseApplicationValidateState = false
        }

        bsoIds.push(element.bsoId)
      })
      if (!this.validateForm()) {
        return
      }
      const filterBsoIds = bsoIds.filter((v, i, a) => a.indexOf(v) === i)
      if (filterBsoIds.length !== bsoIds.length) {
        this.$noty.error(this.$i18n.t('Внимание! В форме выбраны повторяющиеся номера БСО.'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        return
      }
      License.saveFaunaLicenseApplicationBsos(this.licenseApplicationId, { faunaLicenseApplicationData: this.faunaLicenseApplicationData }).then((response) => {
        this.$noty.success(response.status === 202 ? this.$i18n.t('Успешно обновлено') : this.$i18n.t('Успешно добавлено'), {
          killer: true,
          timeout: 1000,
          layout: 'topRight'
        })
        this.$parent.$parent.getFaunaLicenseApplicationBsos()
        this.dialog = false
      })
        .catch((error) => {
          let msg = error.message
          if (error.response) {
            if (error.response.data.form) {
              msg = this.$i18n.t(error.response.data.form.message)
            } else if (error.response.data.message) {
              msg = this.$i18n.t(error.response.data.message)
            }
          }
          this.$noty.error(msg, {
            killer: true,
            timeout: 1000,
            layout: 'topRight'
          })
        })
    },
    // Прокручивание до поля с ошибкой
    scrollToFirstError () {
      const domRect = document.querySelector('.invalid').getBoundingClientRect()
      window.scrollTo(
        domRect.left +
        (document.body.scrollLeft || document.documentElement.scrollLeft),
        domRect.top +
        (document.body.scrollTop || document.documentElement.scrollTop) -
        90
      )
    },
    // Валидация формы
    validateForm () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$nextTick(() => {
          this.scrollToFirstError()
        })

        return false
      }

      return true
    },
    onCancel () {
      this.dialog = false
    }
  }
}
</script>

<style lang="scss" scoped>
h4 {
  text-align: center;
  margin-top: 0;
  margin-bottom: 15px;
}
table {
  margin-bottom: 20px;
  th {
    font-weight: 500;
  }
  td {
    padding-top: 6px;
    padding-bottom: 6px;
  }
}
.select-def, .datepicker-main {
  max-width: 170px;
}
.datepicker-main {
  .datepicker {
    right: 0 !important;
  }
}
</style>
